import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { AdminSidebarComponent } from '../sidebar/admin-sidebar.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { ActivitiesComponent } from '../../shared/components/activities/activities.component';

@Component({
  selector: 'app-admin-activities',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    AdminSidebarComponent,
    PageHeaderComponent,
    ActivitiesComponent
  ],
  templateUrl: './activities.component.html',
  styleUrl: './activities.component.scss',
})
export class AdminActivitiesComponent {
}


